// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4f8b21b3","766":"c98e67a9"}[chunkId] + ".chunk.js";
};